<template #content>
    <Dialog 
        :visible="visible" 
        @update:visible="updateVisible"
        header="Senha"
        @show="onShow"
        @hide="onHide"
        class="w-11 lg:w-3"
        modal >
        <form @submit.prevent="onSubmit(form)">
            <div class="w-full">
                <div class="field mt-4">
                    <FloatLabel>
                        <Password id="current_senha" v-model="form.current_senha" inputClass="w-full" class="w-full" :feedback="false" toggleMask />
                        <label for="current_senha">Senha atual</label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['current_senha'] }}</div>
                </div>
                <div class="field mt-4">
                    <FloatLabel>
                        <Password id="senha" v-model="form.senha" class="w-full" inputClass="w-full" toggleMask />
                        <label for="senha">Nova senha</label>
                    </FloatLabel>
                    <div class="text-xs text-500">Min. 8 caracteres, maiuscula, minuscula, numero e caractere especial.</div>
                    <div class="text-xs text-red-500">{{ errors['senha'] }}</div>
                </div>
                <div class="field mt-4">
                    <FloatLabel>
                        <Password id="confirm_senha" v-model="form.confirm_senha" class="w-full" inputClass="w-full" :feedback="false" toggleMask />
                        <label for="confirm_senha">Confirmar senha</label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['confirm_senha'] }}</div>
                </div>
            </div>

            <div class="flex justify-content-end gap-1">
                <Button 
                    type="submit" 
                    label="Salvar" 
                    severity="success"
                    icon="pi pi-save" 
                    class="flex align-items-center justify-content-center" 
                    :loading="isLoading" />
                <Button 
                    label="Fechar" 
                    severity="warn"
                    icon="pi pi-times" 
                    @click="updateVisible(false)"
                    class="flex align-items-center justify-content-center" 
                    :loading="isLoading" />
            </div>
        </form>

    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Button from 'primevue/button';

import Auth from '@/service/auth.js';

export default {
    components: { Dialog, 
                  FloatLabel, 
                  Button,
                  InputText, 
                  Password,
                  Button
                },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: {}
        },
    },
    emits: ['save','close'],
    data() {
        return {
            form: {},
            errors: {},
            isLoading: false,
        }
    },
    methods: {
        onShow() {
            // ...
        },
        onHide() {
            this.form = {};
        },
        updateVisible(visible) {
            this.$emit('close', visible);
        },
        onSubmit(form) {
            this.errors = {};
            this.isLoading = true;
            Auth.password(form)
                .then(response => {
                    this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: response.data.msg, life: 3000 });
                    this.$emit('save');
                    this.$emit('close');
                })
                .catch(error => {
                    if(error.response) {
                        let err = error.response.data;
                        if(err.erros) {
                            for(let i in err.erros) {
                                this.errors[i] = err.erros[i][0];
                            }
                            return;
                        }
                        if(error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }
}
</script>